export default __webpack_public_path__ + "static/media/icon-youtube.cced2300.svg";